/* eslint-disable */

// This file was automatically generated by @icp-sdk/bindgen@0.4.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { ActorMethod } from '@icp-sdk/core/agent';
import type { Principal } from '@icp-sdk/core/principal';
import { IDL } from '@icp-sdk/core/candid';

export interface Access {
  'balance' : [] | [bigint],
  'minimum_balance' : bigint,
  'error' : [] | [string],
  'ledger' : Principal,
  'account' : Principal,
  'eligible' : boolean,
  'linked_wallet' : [] | [Principal],
  'expires_at' : [] | [bigint],
  'checked_at' : [] | [bigint],
}
export interface Challenge {
  'id' : bigint,
  'owner' : Principal,
  'wallet' : Principal,
  'expires_at' : bigint,
}
export interface Config {
  'minimum_balance' : bigint,
  'freshness_seconds' : bigint,
  'generation' : bigint,
  'enabled' : boolean,
  'ledger' : Principal,
}
export interface Draft { 'kind' : Kind, 'name' : string, 'enabled' : boolean }
export type EventKind = { 'curve_progress' : null } |
  { 'wallet_cluster' : null } |
  { 'large_trade' : null };
export interface Fields {
  'min_liquidity_usd' : [] | [number],
  'max_volume_usd' : [] | [number],
  'base' : [] | [Principal],
  'name' : string,
  'max_mined_percent' : [] | [number],
  'max_marketcap_usd' : [] | [number],
  'max_liquidity_usd' : [] | [number],
  'min_mined_percent' : [] | [number],
  'phase' : { 'all' : null } |
    { 'curve' : null } |
    { 'listed' : null },
  'min_volume_usd' : [] | [number],
  'min_marketcap_usd' : [] | [number],
  'volume_period' : { 'd7' : null } |
    { 'h1' : null } |
    { 'h24' : null },
}
export interface Follow {
  'who' : Principal,
  'after_id' : [] | [bigint],
  'since_at' : bigint,
}
export type Kind = {
    'curve_progress' : { 'threshold_bps' : number, 'market' : Principal }
  } |
  {
    'wallet_cluster' : {
      'count' : bigint,
      'wallets' : Array<Principal>,
      'window_minutes' : bigint,
    }
  } |
  {
    'large_trade' : {
      'min_usd' : number,
      'side' : Side,
      'wallet' : [] | [Principal],
      'market' : [] | [Principal],
    }
  };
export type Mode = { 'native' : null } |
  { 'local_native' : null } |
  { 'local_mirror' : null };
export interface Notification {
  'at' : bigint,
  'id' : bigint,
  'trade' : [] | [Trade],
  'wallet_count' : [] | [bigint],
  'kind' : EventKind,
  'read' : boolean,
  'progress_bps' : [] | [number],
  'market' : Principal,
  'rule_id' : bigint,
  'symbol' : string,
  'rule_name' : string,
}
export interface NotificationPage {
  'next_before' : [] | [bigint],
  'retained_count' : bigint,
  'unread_count' : bigint,
  'items' : Array<Notification__1>,
  'retention_limit' : bigint,
}
export interface Notification__1 {
  'id' : bigint,
  'received_at' : bigint,
  'trade' : Trade,
  'read' : boolean,
}
export interface Page {
  'next_before' : [] | [bigint],
  'retained_count' : bigint,
  'unread_count' : bigint,
  'items' : Array<Notification>,
  'retention_limit' : bigint,
}
export interface PageArgs {
  'offset' : bigint,
  'limit' : bigint,
  'expected_version' : [] | [bigint],
}
export interface Page__1 {
  'status' : { 'refreshing' : null } |
    { 'building' : null } |
    { 'error' : string } |
    { 'ready' : null },
  'total' : bigint,
  'snapshot' : [] | [Snapshot],
  'next_refresh_at' : bigint,
  'mode' : Mode,
  'error' : [] | [string],
  'target' : bigint,
  'page_valid' : boolean,
  'items' : Array<Trader>,
  'next_offset' : [] | [bigint],
  'indexed' : bigint,
  'refresh_interval_seconds' : bigint,
}
export type Phase = { 'backfill' : null } |
  { 'live' : null } |
  { 'build' : null };
export type R = { 'ok' : null } |
  { 'err' : string };
export type R_1 = { 'ok' : Rule } |
  { 'err' : string };
export type R_10 = { 'ok' : Challenge } |
  { 'err' : string };
export type R_2 = { 'ok' : Screener } |
  { 'err' : string };
export type R_3 = { 'ok' : Access } |
  { 'err' : string };
export type R_4 = { 'ok' : Page } |
  { 'err' : string };
export type R_5 = { 'ok' : NotificationPage } |
  { 'err' : string };
export type R_6 = { 'ok' : Array<Screener> } |
  { 'err' : string };
export type R_7 = { 'ok' : Array<Rule> } |
  { 'err' : string };
export type R_8 = { 'ok' : Array<Follow> } |
  { 'err' : string };
export type R_9 = { 'ok' : Config } |
  { 'err' : string };
export interface Rule {
  'id' : bigint,
  'updated_at' : bigint,
  'last_triggered_at' : [] | [bigint],
  'kind' : Kind,
  'name' : string,
  'created_at' : bigint,
  'enabled' : boolean,
}
export interface Screener {
  'id' : bigint,
  'updated_at' : bigint,
  'created_at' : bigint,
  'fields' : Fields,
}
export type Side = { 'any' : null } |
  { 'buy' : null } |
  { 'sell' : null };
export interface Snapshot {
  'updated_at' : bigint,
  'version' : bigint,
  'last_trade_at' : [] | [bigint],
  'trader_count' : bigint,
  'first_trade_at' : [] | [bigint],
  'last_id' : [] | [bigint],
  'first_id' : [] | [bigint],
  'trade_count' : bigint,
}
export interface Trade {
  'at' : bigint,
  'id' : bigint,
  'buy' : boolean,
  'usd' : [] | [number],
  'who' : Principal,
  'base' : bigint,
  'base_ledger' : [] | [Principal],
  'tokens' : bigint,
  'market' : Principal,
  'symbol' : string,
}
export interface TradePage {
  'next_before' : [] | [bigint],
  'snapshot' : [] | [Snapshot],
  'summary' : [] | [Trader],
  'items' : Array<Trade>,
}
export interface Trader {
  'who' : Principal,
  'unpriced_trades' : bigint,
  'unmatched_sell_tokens' : bigint,
  'unmatched_sells' : bigint,
  'realized_pnl_usd' : number,
  'buys' : bigint,
  'trades' : bigint,
  'losing_sells' : bigint,
  'matched_sells' : bigint,
  'sells' : bigint,
  'buy_volume_usd' : number,
  'matched_cost_usd' : number,
  'matched_proceeds_usd' : number,
  'winning_sells' : bigint,
  'last_trade_at' : bigint,
  'unknown_cost_sell_tokens' : bigint,
  'sell_volume_usd' : number,
}
export interface _SERVICE {
  'advanced_alert_status' : ActorMethod<
    [],
    {
      'inbox_retention' : bigint,
      'max_curve_markets' : bigint,
      'curve_poll_seconds' : bigint,
      'trade_snapshot_at' : [] | [bigint],
      'max_rules_global' : bigint,
      'gate_refresh_seconds' : bigint,
      'curve_last_checked_at' : [] | [bigint],
      'coverage' : string,
      'max_active_accounts' : bigint,
      'max_rules_per_account' : bigint,
      'trade_last_indexed_at' : [] | [bigint],
    }
  >,
  'begin_premium_wallet_link' : ActorMethod<[Principal], R_10>,
  'configure_local' : ActorMethod<
    [
      {
        'source' : [] | [Principal],
        'mode' : { 'local_native' : null } |
          { 'local_mirror' : null },
      },
    ],
    undefined
  >,
  'configure_local_alert_factory' : ActorMethod<[Principal], undefined>,
  'configure_premium' : ActorMethod<
    [
      {
        'minimum_balance' : bigint,
        'enabled' : boolean,
        'ledger' : [] | [Principal],
      },
    ],
    R_9
  >,
  'confirm_premium_wallet_link' : ActorMethod<[Principal, bigint], R>,
  'delete_alert_rule' : ActorMethod<[bigint], R>,
  'delete_screener' : ActorMethod<[bigint], R>,
  'follow_list' : ActorMethod<[], R_8>,
  'index_config' : ActorMethod<
    [],
    {
      'batch_size' : bigint,
      'next_refresh_at' : bigint,
      'source' : Principal,
      'mode' : Mode,
      'error' : [] | [string],
      'needs_fetch' : boolean,
      'target' : bigint,
      'before' : [] | [bigint],
      'phase' : Phase,
      'indexed' : bigint,
      'refresh_interval_seconds' : bigint,
    }
  >,
  'leaderboard' : ActorMethod<[PageArgs], Page__1>,
  'mark_notifications_read' : ActorMethod<[bigint], R>,
  'mark_premium_notifications_read' : ActorMethod<[bigint], R>,
  'mirror_error' : ActorMethod<[string], undefined>,
  'mirror_page' : ActorMethod<[[] | [bigint], Array<Trade>], R>,
  'my_alert_rules' : ActorMethod<[], R_7>,
  'my_screeners' : ActorMethod<[], R_6>,
  'notification_feed' : ActorMethod<[[] | [bigint], bigint], R_5>,
  'premium_config' : ActorMethod<[], Config>,
  'premium_notification_feed' : ActorMethod<[[] | [bigint], bigint], R_4>,
  'premium_status' : ActorMethod<[], R_3>,
  'refresh_premium_access' : ActorMethod<[], R_3>,
  'revoke_premium_wallet_link' : ActorMethod<[], R>,
  'save_alert_rule' : ActorMethod<[[] | [bigint], Draft], R_1>,
  'save_screener' : ActorMethod<[[] | [bigint], Fields], R_2>,
  'set_alert_rule_enabled' : ActorMethod<[bigint, boolean], R_1>,
  'set_follow' : ActorMethod<[Principal, boolean], R>,
  'trader' : ActorMethod<[Principal], [] | [Trader]>,
  'trader_trades' : ActorMethod<[Principal, [] | [bigint], bigint], TradePage>,
  'unlink_premium_wallet' : ActorMethod<[], R>,
}
export const Challenge = IDL.Record({
  'id' : IDL.Nat64,
  'owner' : IDL.Principal,
  'wallet' : IDL.Principal,
  'expires_at' : IDL.Nat64,
});
export const R_10 = IDL.Variant({ 'ok' : Challenge, 'err' : IDL.Text });
export const Config = IDL.Record({
  'minimum_balance' : IDL.Nat,
  'freshness_seconds' : IDL.Nat,
  'generation' : IDL.Nat,
  'enabled' : IDL.Bool,
  'ledger' : IDL.Principal,
});
export const R_9 = IDL.Variant({ 'ok' : Config, 'err' : IDL.Text });
export const R = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
export const Follow = IDL.Record({
  'who' : IDL.Principal,
  'after_id' : IDL.Opt(IDL.Nat64),
  'since_at' : IDL.Nat64,
});
export const R_8 = IDL.Variant({ 'ok' : IDL.Vec(Follow), 'err' : IDL.Text });
export const Mode = IDL.Variant({
  'native' : IDL.Null,
  'local_native' : IDL.Null,
  'local_mirror' : IDL.Null,
});
export const Phase = IDL.Variant({
  'backfill' : IDL.Null,
  'live' : IDL.Null,
  'build' : IDL.Null,
});
export const PageArgs = IDL.Record({
  'offset' : IDL.Nat,
  'limit' : IDL.Nat,
  'expected_version' : IDL.Opt(IDL.Nat),
});
export const Snapshot = IDL.Record({
  'updated_at' : IDL.Nat64,
  'version' : IDL.Nat,
  'last_trade_at' : IDL.Opt(IDL.Nat64),
  'trader_count' : IDL.Nat,
  'first_trade_at' : IDL.Opt(IDL.Nat64),
  'last_id' : IDL.Opt(IDL.Nat64),
  'first_id' : IDL.Opt(IDL.Nat64),
  'trade_count' : IDL.Nat,
});
export const Trader = IDL.Record({
  'who' : IDL.Principal,
  'unpriced_trades' : IDL.Nat,
  'unmatched_sell_tokens' : IDL.Nat,
  'unmatched_sells' : IDL.Nat,
  'realized_pnl_usd' : IDL.Float64,
  'buys' : IDL.Nat,
  'trades' : IDL.Nat,
  'losing_sells' : IDL.Nat,
  'matched_sells' : IDL.Nat,
  'sells' : IDL.Nat,
  'buy_volume_usd' : IDL.Float64,
  'matched_cost_usd' : IDL.Float64,
  'matched_proceeds_usd' : IDL.Float64,
  'winning_sells' : IDL.Nat,
  'last_trade_at' : IDL.Nat64,
  'unknown_cost_sell_tokens' : IDL.Nat,
  'sell_volume_usd' : IDL.Float64,
});
export const Page__1 = IDL.Record({
  'status' : IDL.Variant({
    'refreshing' : IDL.Null,
    'building' : IDL.Null,
    'error' : IDL.Text,
    'ready' : IDL.Null,
  }),
  'total' : IDL.Nat,
  'snapshot' : IDL.Opt(Snapshot),
  'next_refresh_at' : IDL.Nat64,
  'mode' : Mode,
  'error' : IDL.Opt(IDL.Text),
  'target' : IDL.Nat,
  'page_valid' : IDL.Bool,
  'items' : IDL.Vec(Trader),
  'next_offset' : IDL.Opt(IDL.Nat),
  'indexed' : IDL.Nat,
  'refresh_interval_seconds' : IDL.Nat,
});
export const Trade = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'buy' : IDL.Bool,
  'usd' : IDL.Opt(IDL.Float64),
  'who' : IDL.Principal,
  'base' : IDL.Nat,
  'base_ledger' : IDL.Opt(IDL.Principal),
  'tokens' : IDL.Nat,
  'market' : IDL.Principal,
  'symbol' : IDL.Text,
});
export const Side = IDL.Variant({
  'any' : IDL.Null,
  'buy' : IDL.Null,
  'sell' : IDL.Null,
});
export const Kind = IDL.Variant({
  'curve_progress' : IDL.Record({
    'threshold_bps' : IDL.Nat32,
    'market' : IDL.Principal,
  }),
  'wallet_cluster' : IDL.Record({
    'count' : IDL.Nat,
    'wallets' : IDL.Vec(IDL.Principal),
    'window_minutes' : IDL.Nat,
  }),
  'large_trade' : IDL.Record({
    'min_usd' : IDL.Float64,
    'side' : Side,
    'wallet' : IDL.Opt(IDL.Principal),
    'market' : IDL.Opt(IDL.Principal),
  }),
});
export const Rule = IDL.Record({
  'id' : IDL.Nat64,
  'updated_at' : IDL.Nat64,
  'last_triggered_at' : IDL.Opt(IDL.Nat64),
  'kind' : Kind,
  'name' : IDL.Text,
  'created_at' : IDL.Nat64,
  'enabled' : IDL.Bool,
});
export const R_7 = IDL.Variant({ 'ok' : IDL.Vec(Rule), 'err' : IDL.Text });
export const Fields = IDL.Record({
  'min_liquidity_usd' : IDL.Opt(IDL.Float64),
  'max_volume_usd' : IDL.Opt(IDL.Float64),
  'base' : IDL.Opt(IDL.Principal),
  'name' : IDL.Text,
  'max_mined_percent' : IDL.Opt(IDL.Float64),
  'max_marketcap_usd' : IDL.Opt(IDL.Float64),
  'max_liquidity_usd' : IDL.Opt(IDL.Float64),
  'min_mined_percent' : IDL.Opt(IDL.Float64),
  'phase' : IDL.Variant({
    'all' : IDL.Null,
    'curve' : IDL.Null,
    'listed' : IDL.Null,
  }),
  'min_volume_usd' : IDL.Opt(IDL.Float64),
  'min_marketcap_usd' : IDL.Opt(IDL.Float64),
  'volume_period' : IDL.Variant({
    'd7' : IDL.Null,
    'h1' : IDL.Null,
    'h24' : IDL.Null,
  }),
});
export const Screener = IDL.Record({
  'id' : IDL.Nat64,
  'updated_at' : IDL.Nat64,
  'created_at' : IDL.Nat64,
  'fields' : Fields,
});
export const R_6 = IDL.Variant({ 'ok' : IDL.Vec(Screener), 'err' : IDL.Text });
export const Notification__1 = IDL.Record({
  'id' : IDL.Nat64,
  'received_at' : IDL.Nat64,
  'trade' : Trade,
  'read' : IDL.Bool,
});
export const NotificationPage = IDL.Record({
  'next_before' : IDL.Opt(IDL.Nat64),
  'retained_count' : IDL.Nat,
  'unread_count' : IDL.Nat,
  'items' : IDL.Vec(Notification__1),
  'retention_limit' : IDL.Nat,
});
export const R_5 = IDL.Variant({ 'ok' : NotificationPage, 'err' : IDL.Text });
export const EventKind = IDL.Variant({
  'curve_progress' : IDL.Null,
  'wallet_cluster' : IDL.Null,
  'large_trade' : IDL.Null,
});
export const Notification = IDL.Record({
  'at' : IDL.Nat64,
  'id' : IDL.Nat64,
  'trade' : IDL.Opt(Trade),
  'wallet_count' : IDL.Opt(IDL.Nat),
  'kind' : EventKind,
  'read' : IDL.Bool,
  'progress_bps' : IDL.Opt(IDL.Nat32),
  'market' : IDL.Principal,
  'rule_id' : IDL.Nat64,
  'symbol' : IDL.Text,
  'rule_name' : IDL.Text,
});
export const Page = IDL.Record({
  'next_before' : IDL.Opt(IDL.Nat64),
  'retained_count' : IDL.Nat,
  'unread_count' : IDL.Nat,
  'items' : IDL.Vec(Notification),
  'retention_limit' : IDL.Nat,
});
export const R_4 = IDL.Variant({ 'ok' : Page, 'err' : IDL.Text });
export const Access = IDL.Record({
  'balance' : IDL.Opt(IDL.Nat),
  'minimum_balance' : IDL.Nat,
  'error' : IDL.Opt(IDL.Text),
  'ledger' : IDL.Principal,
  'account' : IDL.Principal,
  'eligible' : IDL.Bool,
  'linked_wallet' : IDL.Opt(IDL.Principal),
  'expires_at' : IDL.Opt(IDL.Nat64),
  'checked_at' : IDL.Opt(IDL.Nat64),
});
export const R_3 = IDL.Variant({ 'ok' : Access, 'err' : IDL.Text });
export const Draft = IDL.Record({
  'kind' : Kind,
  'name' : IDL.Text,
  'enabled' : IDL.Bool,
});
export const R_1 = IDL.Variant({ 'ok' : Rule, 'err' : IDL.Text });
export const R_2 = IDL.Variant({ 'ok' : Screener, 'err' : IDL.Text });
export const TradePage = IDL.Record({
  'next_before' : IDL.Opt(IDL.Nat64),
  'snapshot' : IDL.Opt(Snapshot),
  'summary' : IDL.Opt(Trader),
  'items' : IDL.Vec(Trade),
});

export const idlService: IDL.ServiceClass = IDL.Service({
  'advanced_alert_status' : IDL.Func(
      [],
      [
        IDL.Record({
          'inbox_retention' : IDL.Nat,
          'max_curve_markets' : IDL.Nat,
          'curve_poll_seconds' : IDL.Nat,
          'trade_snapshot_at' : IDL.Opt(IDL.Nat64),
          'max_rules_global' : IDL.Nat,
          'gate_refresh_seconds' : IDL.Nat,
          'curve_last_checked_at' : IDL.Opt(IDL.Nat64),
          'coverage' : IDL.Text,
          'max_active_accounts' : IDL.Nat,
          'max_rules_per_account' : IDL.Nat,
          'trade_last_indexed_at' : IDL.Opt(IDL.Nat64),
        }),
      ],
      ['query'],
    ),
  'begin_premium_wallet_link' : IDL.Func([IDL.Principal], [R_10], []),
  'configure_local' : IDL.Func(
      [
        IDL.Record({
          'source' : IDL.Opt(IDL.Principal),
          'mode' : IDL.Variant({
            'local_native' : IDL.Null,
            'local_mirror' : IDL.Null,
          }),
        }),
      ],
      [],
      [],
    ),
  'configure_local_alert_factory' : IDL.Func([IDL.Principal], [], []),
  'configure_premium' : IDL.Func(
      [
        IDL.Record({
          'minimum_balance' : IDL.Nat,
          'enabled' : IDL.Bool,
          'ledger' : IDL.Opt(IDL.Principal),
        }),
      ],
      [R_9],
      [],
    ),
  'confirm_premium_wallet_link' : IDL.Func([IDL.Principal, IDL.Nat64], [R], []),
  'delete_alert_rule' : IDL.Func([IDL.Nat64], [R], []),
  'delete_screener' : IDL.Func([IDL.Nat64], [R], []),
  'follow_list' : IDL.Func([], [R_8], ['query']),
  'index_config' : IDL.Func(
      [],
      [
        IDL.Record({
          'batch_size' : IDL.Nat,
          'next_refresh_at' : IDL.Nat64,
          'source' : IDL.Principal,
          'mode' : Mode,
          'error' : IDL.Opt(IDL.Text),
          'needs_fetch' : IDL.Bool,
          'target' : IDL.Nat,
          'before' : IDL.Opt(IDL.Nat64),
          'phase' : Phase,
          'indexed' : IDL.Nat,
          'refresh_interval_seconds' : IDL.Nat,
        }),
      ],
      ['query'],
    ),
  'leaderboard' : IDL.Func([PageArgs], [Page__1], ['query']),
  'mark_notifications_read' : IDL.Func([IDL.Nat64], [R], []),
  'mark_premium_notifications_read' : IDL.Func([IDL.Nat64], [R], []),
  'mirror_error' : IDL.Func([IDL.Text], [], []),
  'mirror_page' : IDL.Func([IDL.Opt(IDL.Nat64), IDL.Vec(Trade)], [R], []),
  'my_alert_rules' : IDL.Func([], [R_7], ['query']),
  'my_screeners' : IDL.Func([], [R_6], ['query']),
  'notification_feed' : IDL.Func(
      [IDL.Opt(IDL.Nat64), IDL.Nat],
      [R_5],
      ['query'],
    ),
  'premium_config' : IDL.Func([], [Config], ['query']),
  'premium_notification_feed' : IDL.Func(
      [IDL.Opt(IDL.Nat64), IDL.Nat],
      [R_4],
      ['query'],
    ),
  'premium_status' : IDL.Func([], [R_3], ['query']),
  'refresh_premium_access' : IDL.Func([], [R_3], []),
  'revoke_premium_wallet_link' : IDL.Func([], [R], []),
  'save_alert_rule' : IDL.Func([IDL.Opt(IDL.Nat64), Draft], [R_1], []),
  'save_screener' : IDL.Func([IDL.Opt(IDL.Nat64), Fields], [R_2], []),
  'set_alert_rule_enabled' : IDL.Func([IDL.Nat64, IDL.Bool], [R_1], []),
  'set_follow' : IDL.Func([IDL.Principal, IDL.Bool], [R], []),
  'trader' : IDL.Func([IDL.Principal], [IDL.Opt(Trader)], ['query']),
  'trader_trades' : IDL.Func(
      [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat],
      [TradePage],
      ['query'],
    ),
  'unlink_premium_wallet' : IDL.Func([], [R], []),
});

export const idlInitArgs: IDL.Type[] = [];

export const idlFactory: IDL.InterfaceFactory = ({ IDL }) => {
  const Challenge = IDL.Record({
    'id' : IDL.Nat64,
    'owner' : IDL.Principal,
    'wallet' : IDL.Principal,
    'expires_at' : IDL.Nat64,
  });
  const R_10 = IDL.Variant({ 'ok' : Challenge, 'err' : IDL.Text });
  const Config = IDL.Record({
    'minimum_balance' : IDL.Nat,
    'freshness_seconds' : IDL.Nat,
    'generation' : IDL.Nat,
    'enabled' : IDL.Bool,
    'ledger' : IDL.Principal,
  });
  const R_9 = IDL.Variant({ 'ok' : Config, 'err' : IDL.Text });
  const R = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const Follow = IDL.Record({
    'who' : IDL.Principal,
    'after_id' : IDL.Opt(IDL.Nat64),
    'since_at' : IDL.Nat64,
  });
  const R_8 = IDL.Variant({ 'ok' : IDL.Vec(Follow), 'err' : IDL.Text });
  const Mode = IDL.Variant({
    'native' : IDL.Null,
    'local_native' : IDL.Null,
    'local_mirror' : IDL.Null,
  });
  const Phase = IDL.Variant({
    'backfill' : IDL.Null,
    'live' : IDL.Null,
    'build' : IDL.Null,
  });
  const PageArgs = IDL.Record({
    'offset' : IDL.Nat,
    'limit' : IDL.Nat,
    'expected_version' : IDL.Opt(IDL.Nat),
  });
  const Snapshot = IDL.Record({
    'updated_at' : IDL.Nat64,
    'version' : IDL.Nat,
    'last_trade_at' : IDL.Opt(IDL.Nat64),
    'trader_count' : IDL.Nat,
    'first_trade_at' : IDL.Opt(IDL.Nat64),
    'last_id' : IDL.Opt(IDL.Nat64),
    'first_id' : IDL.Opt(IDL.Nat64),
    'trade_count' : IDL.Nat,
  });
  const Trader = IDL.Record({
    'who' : IDL.Principal,
    'unpriced_trades' : IDL.Nat,
    'unmatched_sell_tokens' : IDL.Nat,
    'unmatched_sells' : IDL.Nat,
    'realized_pnl_usd' : IDL.Float64,
    'buys' : IDL.Nat,
    'trades' : IDL.Nat,
    'losing_sells' : IDL.Nat,
    'matched_sells' : IDL.Nat,
    'sells' : IDL.Nat,
    'buy_volume_usd' : IDL.Float64,
    'matched_cost_usd' : IDL.Float64,
    'matched_proceeds_usd' : IDL.Float64,
    'winning_sells' : IDL.Nat,
    'last_trade_at' : IDL.Nat64,
    'unknown_cost_sell_tokens' : IDL.Nat,
    'sell_volume_usd' : IDL.Float64,
  });
  const Page__1 = IDL.Record({
    'status' : IDL.Variant({
      'refreshing' : IDL.Null,
      'building' : IDL.Null,
      'error' : IDL.Text,
      'ready' : IDL.Null,
    }),
    'total' : IDL.Nat,
    'snapshot' : IDL.Opt(Snapshot),
    'next_refresh_at' : IDL.Nat64,
    'mode' : Mode,
    'error' : IDL.Opt(IDL.Text),
    'target' : IDL.Nat,
    'page_valid' : IDL.Bool,
    'items' : IDL.Vec(Trader),
    'next_offset' : IDL.Opt(IDL.Nat),
    'indexed' : IDL.Nat,
    'refresh_interval_seconds' : IDL.Nat,
  });
  const Trade = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'buy' : IDL.Bool,
    'usd' : IDL.Opt(IDL.Float64),
    'who' : IDL.Principal,
    'base' : IDL.Nat,
    'base_ledger' : IDL.Opt(IDL.Principal),
    'tokens' : IDL.Nat,
    'market' : IDL.Principal,
    'symbol' : IDL.Text,
  });
  const Side = IDL.Variant({
    'any' : IDL.Null,
    'buy' : IDL.Null,
    'sell' : IDL.Null,
  });
  const Kind = IDL.Variant({
    'curve_progress' : IDL.Record({
      'threshold_bps' : IDL.Nat32,
      'market' : IDL.Principal,
    }),
    'wallet_cluster' : IDL.Record({
      'count' : IDL.Nat,
      'wallets' : IDL.Vec(IDL.Principal),
      'window_minutes' : IDL.Nat,
    }),
    'large_trade' : IDL.Record({
      'min_usd' : IDL.Float64,
      'side' : Side,
      'wallet' : IDL.Opt(IDL.Principal),
      'market' : IDL.Opt(IDL.Principal),
    }),
  });
  const Rule = IDL.Record({
    'id' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
    'last_triggered_at' : IDL.Opt(IDL.Nat64),
    'kind' : Kind,
    'name' : IDL.Text,
    'created_at' : IDL.Nat64,
    'enabled' : IDL.Bool,
  });
  const R_7 = IDL.Variant({ 'ok' : IDL.Vec(Rule), 'err' : IDL.Text });
  const Fields = IDL.Record({
    'min_liquidity_usd' : IDL.Opt(IDL.Float64),
    'max_volume_usd' : IDL.Opt(IDL.Float64),
    'base' : IDL.Opt(IDL.Principal),
    'name' : IDL.Text,
    'max_mined_percent' : IDL.Opt(IDL.Float64),
    'max_marketcap_usd' : IDL.Opt(IDL.Float64),
    'max_liquidity_usd' : IDL.Opt(IDL.Float64),
    'min_mined_percent' : IDL.Opt(IDL.Float64),
    'phase' : IDL.Variant({
      'all' : IDL.Null,
      'curve' : IDL.Null,
      'listed' : IDL.Null,
    }),
    'min_volume_usd' : IDL.Opt(IDL.Float64),
    'min_marketcap_usd' : IDL.Opt(IDL.Float64),
    'volume_period' : IDL.Variant({
      'd7' : IDL.Null,
      'h1' : IDL.Null,
      'h24' : IDL.Null,
    }),
  });
  const Screener = IDL.Record({
    'id' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
    'created_at' : IDL.Nat64,
    'fields' : Fields,
  });
  const R_6 = IDL.Variant({ 'ok' : IDL.Vec(Screener), 'err' : IDL.Text });
  const Notification__1 = IDL.Record({
    'id' : IDL.Nat64,
    'received_at' : IDL.Nat64,
    'trade' : Trade,
    'read' : IDL.Bool,
  });
  const NotificationPage = IDL.Record({
    'next_before' : IDL.Opt(IDL.Nat64),
    'retained_count' : IDL.Nat,
    'unread_count' : IDL.Nat,
    'items' : IDL.Vec(Notification__1),
    'retention_limit' : IDL.Nat,
  });
  const R_5 = IDL.Variant({ 'ok' : NotificationPage, 'err' : IDL.Text });
  const EventKind = IDL.Variant({
    'curve_progress' : IDL.Null,
    'wallet_cluster' : IDL.Null,
    'large_trade' : IDL.Null,
  });
  const Notification = IDL.Record({
    'at' : IDL.Nat64,
    'id' : IDL.Nat64,
    'trade' : IDL.Opt(Trade),
    'wallet_count' : IDL.Opt(IDL.Nat),
    'kind' : EventKind,
    'read' : IDL.Bool,
    'progress_bps' : IDL.Opt(IDL.Nat32),
    'market' : IDL.Principal,
    'rule_id' : IDL.Nat64,
    'symbol' : IDL.Text,
    'rule_name' : IDL.Text,
  });
  const Page = IDL.Record({
    'next_before' : IDL.Opt(IDL.Nat64),
    'retained_count' : IDL.Nat,
    'unread_count' : IDL.Nat,
    'items' : IDL.Vec(Notification),
    'retention_limit' : IDL.Nat,
  });
  const R_4 = IDL.Variant({ 'ok' : Page, 'err' : IDL.Text });
  const Access = IDL.Record({
    'balance' : IDL.Opt(IDL.Nat),
    'minimum_balance' : IDL.Nat,
    'error' : IDL.Opt(IDL.Text),
    'ledger' : IDL.Principal,
    'account' : IDL.Principal,
    'eligible' : IDL.Bool,
    'linked_wallet' : IDL.Opt(IDL.Principal),
    'expires_at' : IDL.Opt(IDL.Nat64),
    'checked_at' : IDL.Opt(IDL.Nat64),
  });
  const R_3 = IDL.Variant({ 'ok' : Access, 'err' : IDL.Text });
  const Draft = IDL.Record({
    'kind' : Kind,
    'name' : IDL.Text,
    'enabled' : IDL.Bool,
  });
  const R_1 = IDL.Variant({ 'ok' : Rule, 'err' : IDL.Text });
  const R_2 = IDL.Variant({ 'ok' : Screener, 'err' : IDL.Text });
  const TradePage = IDL.Record({
    'next_before' : IDL.Opt(IDL.Nat64),
    'snapshot' : IDL.Opt(Snapshot),
    'summary' : IDL.Opt(Trader),
    'items' : IDL.Vec(Trade),
  });

  return IDL.Service({
    'advanced_alert_status' : IDL.Func(
        [],
        [
          IDL.Record({
            'inbox_retention' : IDL.Nat,
            'max_curve_markets' : IDL.Nat,
            'curve_poll_seconds' : IDL.Nat,
            'trade_snapshot_at' : IDL.Opt(IDL.Nat64),
            'max_rules_global' : IDL.Nat,
            'gate_refresh_seconds' : IDL.Nat,
            'curve_last_checked_at' : IDL.Opt(IDL.Nat64),
            'coverage' : IDL.Text,
            'max_active_accounts' : IDL.Nat,
            'max_rules_per_account' : IDL.Nat,
            'trade_last_indexed_at' : IDL.Opt(IDL.Nat64),
          }),
        ],
        ['query'],
      ),
    'begin_premium_wallet_link' : IDL.Func([IDL.Principal], [R_10], []),
    'configure_local' : IDL.Func(
        [
          IDL.Record({
            'source' : IDL.Opt(IDL.Principal),
            'mode' : IDL.Variant({
              'local_native' : IDL.Null,
              'local_mirror' : IDL.Null,
            }),
          }),
        ],
        [],
        [],
      ),
    'configure_local_alert_factory' : IDL.Func([IDL.Principal], [], []),
    'configure_premium' : IDL.Func(
        [
          IDL.Record({
            'minimum_balance' : IDL.Nat,
            'enabled' : IDL.Bool,
            'ledger' : IDL.Opt(IDL.Principal),
          }),
        ],
        [R_9],
        [],
      ),
    'confirm_premium_wallet_link' : IDL.Func(
        [IDL.Principal, IDL.Nat64],
        [R],
        [],
      ),
    'delete_alert_rule' : IDL.Func([IDL.Nat64], [R], []),
    'delete_screener' : IDL.Func([IDL.Nat64], [R], []),
    'follow_list' : IDL.Func([], [R_8], ['query']),
    'index_config' : IDL.Func(
        [],
        [
          IDL.Record({
            'batch_size' : IDL.Nat,
            'next_refresh_at' : IDL.Nat64,
            'source' : IDL.Principal,
            'mode' : Mode,
            'error' : IDL.Opt(IDL.Text),
            'needs_fetch' : IDL.Bool,
            'target' : IDL.Nat,
            'before' : IDL.Opt(IDL.Nat64),
            'phase' : Phase,
            'indexed' : IDL.Nat,
            'refresh_interval_seconds' : IDL.Nat,
          }),
        ],
        ['query'],
      ),
    'leaderboard' : IDL.Func([PageArgs], [Page__1], ['query']),
    'mark_notifications_read' : IDL.Func([IDL.Nat64], [R], []),
    'mark_premium_notifications_read' : IDL.Func([IDL.Nat64], [R], []),
    'mirror_error' : IDL.Func([IDL.Text], [], []),
    'mirror_page' : IDL.Func([IDL.Opt(IDL.Nat64), IDL.Vec(Trade)], [R], []),
    'my_alert_rules' : IDL.Func([], [R_7], ['query']),
    'my_screeners' : IDL.Func([], [R_6], ['query']),
    'notification_feed' : IDL.Func(
        [IDL.Opt(IDL.Nat64), IDL.Nat],
        [R_5],
        ['query'],
      ),
    'premium_config' : IDL.Func([], [Config], ['query']),
    'premium_notification_feed' : IDL.Func(
        [IDL.Opt(IDL.Nat64), IDL.Nat],
        [R_4],
        ['query'],
      ),
    'premium_status' : IDL.Func([], [R_3], ['query']),
    'refresh_premium_access' : IDL.Func([], [R_3], []),
    'revoke_premium_wallet_link' : IDL.Func([], [R], []),
    'save_alert_rule' : IDL.Func([IDL.Opt(IDL.Nat64), Draft], [R_1], []),
    'save_screener' : IDL.Func([IDL.Opt(IDL.Nat64), Fields], [R_2], []),
    'set_alert_rule_enabled' : IDL.Func([IDL.Nat64, IDL.Bool], [R_1], []),
    'set_follow' : IDL.Func([IDL.Principal, IDL.Bool], [R], []),
    'trader' : IDL.Func([IDL.Principal], [IDL.Opt(Trader)], ['query']),
    'trader_trades' : IDL.Func(
        [IDL.Principal, IDL.Opt(IDL.Nat64), IDL.Nat],
        [TradePage],
        ['query'],
      ),
    'unlink_premium_wallet' : IDL.Func([], [R], []),
  });
};

export const init: (args: { IDL: typeof IDL }) => IDL.Type[] = ({ IDL }) => {
  return [];
};
